import { z } from 'zod'
import { TrueFalse } from '~/enums/true-false'
import { productFileSchema } from './product-file'

/**
 * 產品子網頁 - 單筆資料 Schema
 */
export const productPagesDataSchema = z.object({
  /** ID */
  ppID: z.number().optional(),
  /** 產品主類目 ID */
  pmID: z.number().optional(),
  /** 產品子類目 ID */
  psID: z.number().optional(),
  /** 產品子網頁分類 ID */
  psiID: z.number().optional(),
  /** 發布時間 */
  releaseDate: z.string(),
  /** 更新時間 */
  modifyDate: z.string(),
  /** 更新者 */
  modifyUser: z.string(),
  /** 作者 */
  author: z.string(),
  /** 是否置頂 */
  isTop: z.nativeEnum(TrueFalse),
  /** 是否上架 */
  isEnable: z.nativeEnum(TrueFalse),
  /** 標題-中文版 */
  titleZh: z.string(),
  /** 標題-英文版 */
  titleEn: z.string(),
  /** Tag 標籤-中文版 */
  tagLabelZh: z.string().nullable(),
  /** Tag 標籤-英文版 */
  tagLabelEn: z.string().nullable(),
  /** 內容-中文版 */
  contentZh: z.string().nullable(),
  /** 內容-英文版 */
  contentEn: z.string().nullable(),
  /** 檔案上傳-中文版 */
  uploadFilesZh: z.array(productFileSchema),
  /** 檔案上傳-英文版 */
  uploadFilesEn: z.array(productFileSchema)
})

/**
 * 產品子網頁 - 單筆資料 Schema
 */
export interface ProductPagesData
  extends z.infer<typeof productPagesDataSchema> {}

export class ProductPagesData {
  constructor() {
    return {
      ppID: undefined,
      pmID: undefined,
      psID: undefined,
      psiID: undefined,
      releaseDate: '',
      isEnable: TrueFalse.TRUE,
      isTop: TrueFalse.FALSE,
      author: '',
      titleZh: '',
      titleEn: '',
      tagLabelZh: null,
      tagLabelEn: null,
      contentZh: null,
      contentEn: null,
      uploadFilesZh: [],
      uploadFilesEn: [],
      modifyDate: '',
      modifyUser: ''
    }
  }
}
